import { jsx as _jsx } from "react/jsx-runtime";
import EducationClassroom from "./EducationClassroom";
export default function EduMath() {
    return (_jsx(EducationClassroom, { subject: "math", title: "Math Classroom", description: "Learn broader mathematics with Ava at your selected grade level.", placeholder: "Ask a math question, such as: How do I solve 3x + 5 = 20?" }));
}
